import { render, staticRenderFns } from "./dataAgent.vue?vue&type=template&id=98f1cae8&scoped=true&"
import script from "./dataAgent.vue?vue&type=script&lang=js&"
export * from "./dataAgent.vue?vue&type=script&lang=js&"
import style0 from "./dataAgent.vue?vue&type=style&index=0&id=98f1cae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f1cae8",
  null
  
)

export default component.exports